import { narrativeErrorStatuses, narrativeStatus } from '@helpers';

export const COMPLETED_OR_ERROR_FLOW_STATUSES = [
  narrativeStatus.COMPLETED,
  ...narrativeErrorStatuses,
];

export const DEFAULT_PROMPT_MODAL_NAME = 'Narrative prompts';
export const DEFAULT_PROMPT_ROUTE_LABEL = 'Selected prompts';
export const UNTITLED_TOPIC_FALLBACK = 'Untitled Topic';

export const TOPIC_CARD_MOTION_PROPS = {
  animate: { opacity: 1, scale: 1, y: 0 },
  exit: { height: 0, marginBottom: 0, opacity: 0, scale: 0.98, y: -12 },
  initial: { opacity: 0, scale: 0.98, y: 12 },
  transition: {
    height: { duration: 0.25, ease: 'easeInOut' },
    layout: { duration: 0.3, ease: 'easeInOut' },
    opacity: { duration: 0.2 },
    scale: { duration: 0.25, ease: 'easeOut' },
    y: { duration: 0.25, ease: 'easeOut' },
  },
};
